/**
 * Created by quikr on 11/4/16.
 */


const balance = {};
const optional = {optional: []};
const history = {history: []};
const team = {team: []};
const teamHistory = {teamHistory: []};
const teamWeekly = {teamWeekly: []};
const ledger = {ledger: []}

export default function leaveReducer(state = [balance, optional, history, team, teamHistory, teamWeekly, ledger], action) {
  switch (action.type) {
    case 'GET_LEAVE_BALANCE_SUCCESS':
      return [action.balance, state[1], state[2], state[3], state[4], state[5], state[6]];
    case 'GET_OPTIONAL_LEAVES_SUCCESS':
      return [state[0], action.optional, state[2], state[3], state[4], state[5], state[6]];
    case 'GET_LEAVE_HISTORY_SUCCESS':
      return [state[0], state[1], action.history, state[3], state[4], state[5], state[6]];
    case 'GET_TEAM_LEAVE_SUCCESS':
      return [state[0], state[1], state[2], action.team, state[4], state[5], state[6]];
    case 'GET_TEAM_LEAVE_HISTORY_SUCCESS':
      return [state[0], state[1], state[2], state[3], action.teamHistory, state[5], state[6]];
    case 'GET_TEAM_WEEKLY_SUCCESS':
      return [state[0], state[1], state[2], state[3], state[4], action.teamWeekly, state[6]];
    case 'GET_LEAVE_LEDGER_SUCCESS':
      return [state[0], state[1], state[2], state[3], state[4], state[5], action.ledger]

    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/leaveReducer.js
 **/